export default __webpack_public_path__ + "app/images/7cdf191c4e44b68151120a14f3a760b1.svg";